import { useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import StaffPlanSummary from '../components/StaffPlanSummary';
import Discipline from '../components/Discipline';
import { isVacantSv } from '../components/SvManage';
import { Topbar, SectionTitle, Loader } from '../components/UI';
import { supabase } from '../lib/supabase';
import { getActivePeriod, getAllTms } from '../lib/data';

// Роль «Тренер»: видит только активности СВ (по ТМ → СВ), без табеля, заказов, статусов и подбора.
export default function TrainerPage() {
  const { user, logout } = useAuth();
  const [period, setPeriod] = useState(null);
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const [p, tms, svRes] = await Promise.all([
          getActivePeriod(),
          getAllTms(),
          supabase.from('supervisors').select('id, full_name, internal_code, tm_id').eq('is_active', true).order('full_name').limit(5000),
        ]);
        if (svRes.error) throw svRes.error;
        setPeriod(p);
        const svs = (svRes.data || []).filter(s => !isVacantSv(s));
        const list = tms.map(tm => {
          const kids = svs.filter(s => s.tm_id === tm.id)
            .map(s => ({ id: s.id, label: s.full_name, sub: s.internal_code, svIds: [s.id] }));
          return { id: tm.id, label: tm.full_name, sub: `${kids.length} СВ`, svIds: kids.flatMap(k => k.svIds), children: kids };
        }).filter(u => u.children.length);
        setUnits(list);
      } catch (e) {
        setErr(e.message || 'Не удалось загрузить данные');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <Loader text="Загружаем..." />;

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Topbar
        title={user.full_name}
        subtitle="Тренер проекта — активности СВ"
        rightContent={
          <button onClick={logout} style={{ background: 'rgba(255,255,255,.12)', border: 'none', color: 'white', padding: '6px 12px', borderRadius: 6, fontSize: 12 }}>Выйти</button>
        }
      />
      <div style={{ padding: 16, maxWidth: 900, margin: '0 auto', width: '100%' }}>
        <SectionTitle>{period?.name} — активности СВ</SectionTitle>
        {err && <div style={{ fontSize: 12, color: 'var(--red)', marginBottom: 8 }}>{err}</div>}
        <Discipline period={period} weeks={period?.work_weeks || []} units={units} title="Активности СВ по ТМ" />
        <div style={{ height: 16 }} />
        <SectionTitle>Планирование кадров СВ</SectionTitle>
        <StaffPlanSummary mode="trainer" />
      </div>
    </div>
  );
}
